export default "__VITE_PUBLIC_ASSET__0422a2eb__"